import { render } from "./DiagnosisSpeed.vue?vue&type=template&id=31b311f8&ts=true"
import script from "./DiagnosisSpeed.vue?vue&type=script&lang=ts"
export * from "./DiagnosisSpeed.vue?vue&type=script&lang=ts"

import "./DiagnosisSpeed.vue?vue&type=style&index=0&id=31b311f8&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__